/**
*
* CompanyInfo
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { object, string } from 'yup';
import FormControl from 'components/interaction/Form4/FormControl.jsx';
import FormControlWrapper from 'components/interaction/Form4/FormControlWrapper.jsx';
import messages from './messages.js';

const Wrapper = styled(FormControlWrapper)`
  .w25 {
    min-width: 6em;
  }
`;

function CompanyInfo(props) {
  const { value, onChange, required, ...rest } = props;
  if (!value) {
    return null;
  }

  function handleChange(key) {
    return (ev) => {
      onChange({ ...value, [key]: ev.target.value });
    };
  }

  return (
    <Wrapper border={2} {...rest}>
      <div className="mb-4">
        <FormControl type="text" value={value.name || ''} required={required} placeholder={messages.name} onChange={handleChange('name')} />
      </div>
      <div className="mb-4">
        <FormControl type="text" value={value.address || ''} placeholder={messages.street} required={required} onChange={handleChange('address')} />
      </div>
      <div className="d-flex">
        <FormControl className="w-25 me-3" type="text" value={value.postalCode || ''} placeholder={messages.postalCode} required={required} onChange={handleChange('postalCode')} />
        <FormControl type="text" value={value.city || ''} placeholder={messages.city} required={required} onChange={handleChange('city')} />
      </div>
    </Wrapper>
  );
}

CompanyInfo.propTypes = {
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
};

function makeSchema(options, intl) {
  const result = {};
  const { required } = options;
  ['name', 'address', 'postalCode', 'city'].forEach((key) => {
    result[key] = (required ? string().trim().required() : string().trim()).label(intl.formatMessage(messages[key]));
  });
  return result;
}

CompanyInfo.getSchema = (options, intl) => object().shape(makeSchema(options, intl));

export default CompanyInfo;
